import rtkApis from '@rtkApis';
import parentApi from '../store/parentApi';

const bundlesApis = parentApi.injectEndpoints({
  endpoints: (build) => ({
    getBundles: build.query({
      query: () => rtkApis.getBundles.query(),
      transformResponse: (response, meta, args) => rtkApis.getBundles?.transformer(response, meta, args),
      providesTags: ['bundles'],
    }),
  }),
});

export const { useGetBundlesQuery } = bundlesApis;
